export enum TicketLevel {
    Level0,
    Level1,
    Level2,
    Level3,
    Level4
}
